import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import '../styles.less'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ProjectManageStructureWidget from '../../../widgets/projectProposal/projectManagementStructure/ProjectManageStructureWidget'
import ProjectOrganizationWidget from '../../../widgets/projectProposal/projectOrganization/ProjectOrganizationWidget'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getProjectManagement } from '../../../redux/actions/projectManagement'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import pathname from '../../../constants/pathname'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import ViewPreviousVersionButon from '../../../components/buttons/viewPreviousVersionButon/ViewPreviousVersionButon'
import { Panel } from 'rsuite'

export default function ProjectManagementStructure() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [schemaPrevious, setSchemaPrevious] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isViewPrevious, setIsViewPrevious] = useState(false)
  const [error, setError] = useState()
  const [showEditAll, setShowEditAll] = useState()
  const [buttonRoutes, setButtonRoutes] = useState()
  
  const previousPanelRef = useRef(null)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (projectId) {
      handleGetSchema(projectId)
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  useEffect(() => {
    if (schema) {
      setButtonRoutePathname(schema?.formTemplate)
    }
  }, [schema])

  useEffect(() => {
    if (isViewPrevious && schemaPrevious) {
      previousPanelRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }, [isViewPrevious, schemaPrevious])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectManagement(proposalId)
      setSchema(_schema)

      setIsEditWidget({
        projectManagement: _schema.forms?.projectManagement?.role?.value.length > 0 ? false : true,
        organization: _schema.forms?.organization?.values.length > 0 ? false : true,
      })
      
      setShowEditAll(
        !_schema.forms?.projectManagement?.disabled && !_schema.forms?.organization?.disabled
      )
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPrevious = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      if (isViewPrevious) {
        setIsViewPrevious(false)
        doneLoading()
        setIsLoading(false)
        return
      }
      if (schemaPrevious) {
        setIsViewPrevious(true)
        doneLoading()
        setIsLoading(false)
        return
      }
      const _schema = await getProjectManagement(id)
      setSchemaPrevious(_schema)
      setIsViewPrevious(true)
    } catch (e) {
      console.error(e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const setButtonRoutePathname = (formTemplate) => {
    if (formTemplate === 0 || typeof formTemplate == 'undefined') {
      setButtonRoutes({
        pathNameBackward: `${pathname.proposal.monitoringAndInternalEvaluation}`,
        pathNameForward: `${pathname.proposal.budget}`,
      })
    } else {
      setButtonRoutes({
        pathNameBackward: `${pathname.proposal.workingGroup}`,
        pathNameForward: `${pathname.proposal.budget}`,
      })
    }
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  // 🚩 ก้อนที่ 1: จับข้อมูล "เวอร์ชันปัจจุบัน" มัดรวมไว้ในตัวแปรนี้ จะได้ไม่ต้องเขียนโค้ดซ้ำ 2 รอบ
  const renderCurrentVersion = (
    <div className="top">
      {schema?.forms?.projectManagement && (
        <>
          <ProjectManageStructureWidget
            showCommandButton={!schema.forms.projectManagement.disabled}
            schema={schema.forms.projectManagement}
            isEdit={isEditWidget.projectManagement}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('projectManagement', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}

      {schema?.forms?.organization && (
        <>
          <ProjectOrganizationWidget
            showCommandButton={!schema.forms.organization.disabled}
            schema={schema.forms.organization}
            isEdit={isEditWidget.organization}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('organization', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}
    </div>
  )

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ViewPreviousVersionButon 
        handleGetSchemaPrevious={handleGetSchemaPrevious} 
        isViewPrevious={isViewPrevious}
        masterSubjectId={'1-1025,5-5010'}
      />

      {showEditAll && (
        <BtnEditAll
          onClickEditAll={getIsEditAll(isEditWidget)}
          routing={buttonRoutes}
          setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
          editWidget={isEditWidget}
          forms={schema?.forms}
        />
      )}

      <div className="wrapper">
        <div style={!isViewPrevious ? { width: '100%' } : {}}>
          {isViewPrevious ? (
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              bodyFill
              header={'version ปัจจุบัน'}
              style={{ maxHeight: '550px', overflowY: 'auto', width: '100%' }}
            >
              {renderCurrentVersion}
            </Panel>
          ) : (
            renderCurrentVersion
          )}
        </div>

        {isViewPrevious && schemaPrevious && (
          <div ref={previousPanelRef}>
            <div className="line" />
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              bodyFill
              header={'version ก่อนหน้า'}
              style={{ maxHeight: '550px', overflowY: 'auto', width: '100%', backgroundColor: '#e4e4ed' }}
            >
              <div className="bottom">
                {schemaPrevious?.forms?.projectManagement && (
                  <>
                    <ProjectManageStructureWidget
                      showCommandButton={false}
                      schema={schemaPrevious.forms.projectManagement}
                      isEdit={false}
                    />
                    <br />
                  </>
                )}

                {schemaPrevious?.forms?.organization && (
                  <>
                    <ProjectOrganizationWidget
                      showCommandButton={false}
                      schema={schemaPrevious.forms.organization}
                      isEdit={false}
                    />
                    <br />
                  </>
                )}
              </div>
            </Panel>
            <br />
            <br />
          </div>
        )}
      </div>
    </SidebarProposal>
  )
}
